import { render, staticRenderFns } from "./AdminUnitsView.vue?vue&type=template&id=3f46cfc4&scoped=true&"
import script from "./AdminUnitsView.vue?vue&type=script&lang=js&"
export * from "./AdminUnitsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46cfc4",
  null
  
)

export default component.exports